import { getLeaderboard } from '../api';
import { useTournamentsLeaderboardsStore } from './store';
import { ActionsCreatorParams, LeaderBoardData } from './types';

export const actionsCreator = ({ setState }: ActionsCreatorParams) => ({
  GET_LEADERBOARD_INFO: async (tournamentId: string | number) => {
    const response = await getLeaderboard(tournamentId);

    setState((state) => {
      return {
        ...state,
        tournamentsLeaderboards: {
          ...state.tournamentsLeaderboards,
          [tournamentId]: response.data
        }
      };
    });
  },

  SET_LEADERBOARD_INFO: async (
    leaderboardInfo: LeaderBoardData,
    tournamentId: string | number
  ) => {
    setState((state) => {
      return {
        ...state,
        tournamentsLeaderboards: {
          ...state.tournamentsLeaderboards,
          [tournamentId]: leaderboardInfo
        }
      };
    });
  }
});

export const tournamentsLeaderboardsActions = actionsCreator(
  useTournamentsLeaderboardsStore
);
